export default {
  aboutHero: {
    label: 'ABOUT DRA',
    title: "DRA's Philosophy",
  },
  philosophy: {
    label: 'THE INQUIRY',
    title: 'Designing Inevitability,\nRedefining Education',
    quote: 'Education is not a "spiritual theory" that believes in possibilities,\nbut a "provision of structure" that actualizes possibilities.',
    body1: 'We have continued to question the "uncertainty" in the field of education. Why do individual qualities and efforts not necessarily lead to sustainable results?',
    body2: 'The fundamental cause is not a lack of individual ability, but the "cognitive structure" that individuals unconsciously hold and the "lack of a system" to reconstruct it.',
    footer: 'DRA is an institution that organizes the chain of thought, action, and results, and systematizes it as education.',
  },
  founding: {
    label: 'CORE LOGIC',
    title: 'Cognitive Formation Until Age 18,\nAnd Beyond',
    body1: 'Over 90% of human decision-making depends on unconscious cognitive patterns (OS) formed by age 18.',
    body2: 'DRA objectively visualizes this inherent structure and supports autonomous redesign (Re-structure) through the scientifically-based "DREAM CODE".',
    conclusion: 'We believe that education should not be a "spiritual theory" that believes in possibilities,\nbut a "provision of structure" that actualizes possibilities.',
    pillar1: { label: 'Cognition', desc: 'Visualize unconscious structure' },
    pillar2: { label: 'Redesign', desc: 'Reconstruction based on scientific perspective' },
    pillar3: { label: 'Reproducibility', desc: 'Systematization of sustainable results' },
  },
  founder: {
    label: 'FOUNDER AS AN ARCHITECT',
    title: 'Founder / Chairman Shinji Hirose — Message',
    subtitle: 'Why Structure Now',
    quote: '"We give not passion, but reproducibility."',
    description: 'The founder as an architect of thought. Discusses the essence of structured education advocated by DRA and the design philosophy that leads individuals and organizations to fundamental transformation.',
  },
  award: {
    label: 'GLOBAL RECOGNITION',
    title: 'The New Standard of\nEducational Framework Recognized by the World',
    intro: 'In 2026, at the United Nations Headquarters in New York. The social significance of "structured education" advocated by DRA and the design philosophy that leads individuals and organizations to fundamental transformation were evaluated and awarded at an international conference. This is not a temporary boom, but recognition as the next generation global standard.',
    year: '2026',
    location: 'NEW YORK',
    awardTitle: 'UN CSW70 Related Forum\nRecipient of the "Outstanding Contribution Award"',
    point1: 'Recognition of a unique method integrating neuroscience, behavioral psychology, and AI',
    point2: 'Contribution to women\'s empowerment and next-generation leader development',
    point3: 'International recognition from UN ECOSOC Special Consultative Status organization (IDIO)',
    note: 'Recognized for outstanding contributions to social development and the field of education, DRA was honored with a prestigious international award. The innovation and effectiveness of DRA\'s approach — grounded in the "structure" of cognition rather than spiritual theory — have been proven on the world\'s most prestigious stage.',
    buttonText: 'View Awards & Activities',
  },
};